<script setup lang="ts">
import { ref, onMounted } from 'vue'

const emit = defineEmits<{
  'go-home': []
}>()

const showScreen = ref(false)

onMounted(() => {
  setTimeout(() => {
    showScreen.value = true
  }, 100)
})

const goHome = () => {
  emit('go-home')
}
</script>

<template>
  <div class="screen min-h-screen bg-gradient-to-br from-red-50 to-red-100 flex items-center justify-center p-4">
    <transition
      appear
      enter-active-class="transition-all duration-500 ease-out"
      enter-from-class="opacity-0 scale-90"
      enter-to-class="opacity-100 scale-100"
    >
      <div 
        v-if="showScreen"
        class="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center"
      >
        <!-- Icono de desconexión -->
        <div class="mb-6">
          <div class="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full">
            <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
        </div>

        <!-- Título -->
        <h1 class="text-3xl font-bold text-gray-800 mb-4">
          ¡Conexión Perdida!
        </h1>

        <!-- Descripción -->
        <p class="text-lg text-gray-600 mb-8">
          El host se ha desconectado y el juego ha terminado.
        </p>

        <!-- Botón de acción -->
        <button
          @click="goHome"
          class="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
        >
          🏠 Volver al Inicio
        </button>

        <!-- Información adicional -->
        <div class="mt-6 p-4 bg-red-50 rounded-lg border border-red-200">
          <p class="text-sm text-red-800">
            <strong>Nota:</strong> Si quieres jugar de nuevo, crea una nueva sala o únete a una existente.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.screen {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>